module.exports = __webpack_public_path__ + "static/media/excel-policies-cover-image.b4649fac.png";